import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo } from 'react';
import * as classnames from 'classnames';
import { Dialog, Popover } from '@mui/material';
import { any2unix, isSameDay, rusDateNoYear, rusDateOnly, todayEndToUnix, todayStartToUnix, yesterdayEndToUnix, yesterdayStartToUnix, } from 'utils';
import './tracking-period.sass';
import { usePartial, useRefAnchor } from 'shared/hooks/utils';
import { PeriodPicker } from './period-picker';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
export const PeriodWidget = memo(function PeriodWidget({ mintime, maxtime, onDatesSelected, isActive, }) {
    const [anchor, ref, openPopup, closePopup] = useRefAnchor();
    const select_today = usePartial(onDatesSelected, todayStartToUnix(), todayEndToUnix());
    const select_yesterday = usePartial(onDatesSelected, yesterdayStartToUnix(), yesterdayEndToUnix());
    const select_by_calendar = useCallback((from, to) => {
        onDatesSelected(any2unix(from), any2unix(to));
    }, [onDatesSelected]);
    const custom_text = useMemo(() => {
        const a = new Date(mintime * 1e3);
        const b = new Date(maxtime * 1e3);
        if (isSameDay(a, b))
            return rusDateOnly(a);
        if (a.getFullYear() === b.getFullYear())
            return `${rusDateNoYear(a)}–${rusDateOnly(b)}`;
        return `${rusDateOnly(a)}–${rusDateOnly(b)}`;
    }, [mintime, maxtime]);
    const today = new Date();
    const yesterday = new Date(Date.now() - 24 * 60 * 60e3);
    const date_from = mintime != null ? new Date(mintime * 1e3) : null;
    const date_to = maxtime != null ? new Date(maxtime * 1e3) : null;
    const is_today = date_from != null &&
        date_to != null &&
        isSameDay(date_from, today) &&
        isSameDay(date_to, today);
    const is_yesterday = date_from != null &&
        date_to != null &&
        isSameDay(date_from, yesterday) &&
        isSameDay(date_to, yesterday);
    const is_custom = date_from != null && !is_today && !is_yesterday;
    useEffect(() => {
        if (isActive) {
            if (is_today) {
                select_today();
            }
            else if (is_yesterday) {
                select_yesterday();
            }
            // else if (is_custom) {
            //     openPopup();
            // }
        }
    }, [isActive]);
    return (_jsxs("div", { className: "ui-period-widget ui-tracking-period", children: [_jsx("div", { className: 'ui-period-widget-button-wrapper', onClick: select_today, children: _jsx("span", { className: classnames('ui-period-widget-button', {
                        active: is_today,
                    }), children: "\u0421\u0415\u0413\u041E\u0414\u041D\u042F" }) }), _jsx("div", { className: 'ui-period-widget-button-wrapper', onClick: select_yesterday, children: _jsx("span", { className: classnames('ui-period-widget-button', {
                        active: is_yesterday,
                    }), children: "\u0412\u0427\u0415\u0420\u0410" }) }), _jsx("div", { className: 'ui-period-widget-button-wrapper', onClick: openPopup, children: _jsxs("span", { className: classnames('ui-period-widget-button ui-period-widget-last', {
                        active: is_custom,
                    }), ref: ref, children: [_jsx("span", { className: "ui-icon-periodwidget-period" }), _jsx("span", { className: "ui-period-widget-custom", children: is_custom ? custom_text : 'ПЕРИОД' })] }) }), isSmallUI() ? (_jsx(Dialog, { open: Boolean(anchor), onClose: closePopup, keepMounted: true, children: _jsx(PeriodPicker, { onDatesSelected: select_by_calendar, onCancelClick: closePopup }) })) : (_jsx(Popover, { open: Boolean(anchor), anchorEl: anchor, onClose: closePopup, keepMounted: true, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                }, children: _jsx(PeriodPicker, { onDatesSelected: select_by_calendar, onCancelClick: closePopup }) }))] }));
});
